import type { ApexOptions } from 'apexcharts'
import type { SectionPeriod } from '../../../features/engagement/domain/models/sections'
import { buildDualAxisLineChartOptions, ChartColors, type ChartSeriesItem } from '../../shared/charts'
import { formatDurationHours, type TranslateFn } from './section-display'

export const getSectionsTotalsChartOptions = (periods: SectionPeriod[], t: TranslateFn): ApexOptions => {
  const dates = periods.map((p) => p.date)

  const leftSeries: ChartSeriesItem[] = [
    {
      name: t('ls_sections_visits'),
      data: periods.map((p) => p.visits),
      color: ChartColors.blueBright
    },
    {
      name: t('ls_sections_interactions'),
      data: periods.map((p) => p.interactions),
      color: ChartColors.purple
    }
  ]

  const rightSeries: ChartSeriesItem = {
    name: t('ls_sections_time'),
    data: periods.map((p) => p.seconds),
    color: ChartColors.amber
  }

  return buildDualAxisLineChartOptions({
    dates,
    leftSeries,
    rightSeries,
    rightFormatter: formatDurationHours
  })
}
